import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel from 'react-elastic-carousel';
import ItemWithLink from '../components/ItemWithLink';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "autotabindexvisibleitems"
    }}>{`autoTabIndexVisibleItems`}</h1>
    <p>{`Automatically inject `}<inlineCode parentName="p">{`tabIndex:0`}</inlineCode>{` to visible items and `}<inlineCode parentName="p">{`tabIndex:-1`}</inlineCode>{` to none visible items.  `}</p>
    <p><strong parentName="p">{`This prop defaults to `}<inlineCode parentName="strong">{`true`}</inlineCode>{`.`}</strong></p>
    <p>{`In some cases you might want users to directly focus nested elements inside the Item,
so you can grab that `}<inlineCode parentName="p">{`tabIndex`}</inlineCode>{` and pass it to whatever nested element you wish.`}</p>
    <p>{`In this example we pass the injected `}<inlineCode parentName="p">{`tabIndex`}</inlineCode>{` to the `}<inlineCode parentName="p">{`<a/>`}</inlineCode>{` element:`}</p>
    <Playground __position={0} __code={'<input placeholder=\"start focus from here...\" />\n<Carousel itemsToShow={3} autoTabIndexVisibleItems={true}>\n  <ItemWithLink text=\"1\" />\n  <ItemWithLink text=\"2\" />\n  <ItemWithLink text=\"3\" />\n  <ItemWithLink text=\"4\" />\n  <ItemWithLink text=\"5\" />\n  <ItemWithLink text=\"6\" />\n</Carousel>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      ItemWithLink,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <input placeholder="start focus from here..." />
    <Carousel itemsToShow={3} autoTabIndexVisibleItems={true} mdxType="Carousel">
        <ItemWithLink text="1" mdxType="ItemWithLink" />
        <ItemWithLink text="2" mdxType="ItemWithLink" />
        <ItemWithLink text="3" mdxType="ItemWithLink" />
        <ItemWithLink text="4" mdxType="ItemWithLink" />
        <ItemWithLink text="5" mdxType="ItemWithLink" />
        <ItemWithLink text="6" mdxType="ItemWithLink" />
    </Carousel>
    </Playground>
    <h3 {...{
      "id": "link1"
    }}>{`link1`}</h3>
    <p>{`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`}</p>
    <h3 {...{
      "id": "link2"
    }}>{`link2`}</h3>
    <p>{`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`}</p>
    <h3 {...{
      "id": "link3"
    }}>{`link3`}</h3>
    <p>{`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`}</p>
    <h3 {...{
      "id": "link4"
    }}>{`link4`}</h3>
    <p>{`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`}</p>
    <h3 {...{
      "id": "link5"
    }}>{`link5`}</h3>
    <p>{`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`}</p>
    <h3 {...{
      "id": "link6"
    }}>{`link6`}</h3>
    <p>{`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      